export const TEAM_NAME = {
    DOGE: 'doge',
    PEPE: 'pepe',
    WOJAK: 'wojak'
}